var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._v(
        "\n        " +
          _vm._s(_vm.showClosePopUp) +
          _vm._s(_vm.showCloseEditPopUp) +
          _vm._s(_vm.getInvestigationId) +
          "\n        "
      ),
      _vm.show_modal
        ? _c(
            "div",
            [
              _c("transition", { attrs: { name: "modal" } }, [
                _c("div", { staticClass: "modalhold" }, [
                  _c(
                    "div",
                    {
                      staticClass: "modal-mask upl-hold",
                      staticStyle: { "overflow-y": "auto", display: "block" },
                    },
                    [
                      _c("div", { staticClass: "modal-wrapper" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "modal-container wider-midB clinicalnote upload-reports-section",
                          },
                          [
                            _vm.showloader
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "section-loader prescription-popup",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../static/images/loader-icon.png"),
                                        id: "loading",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "modal-headers pb-0 border-bottom-0 pt-0",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ehr-popup-header-colored popup-header-blue",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "ehr-popup-title" },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticStyle: {
                                              width: "18px",
                                              height: "18px",
                                            },
                                            attrs: {
                                              viewBox: "0 0 24 24",
                                              fill: "none",
                                              stroke: "currentColor",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                            },
                                          },
                                          [
                                            _c("polygon", {
                                              attrs: {
                                                points:
                                                  "12 2 2 7 12 12 22 7 12 2",
                                              },
                                            }),
                                            _c("polyline", {
                                              attrs: {
                                                points: "2 17 12 22 22 17",
                                              },
                                            }),
                                            _c("polyline", {
                                              attrs: {
                                                points: "2 12 12 17 22 12",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                                      Upload report\n                                  "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "ehr-popup-close",
                                        attrs: {
                                          type: "button",
                                          "aria-label": "Close",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.closePopUp("goBack")
                                          },
                                        },
                                      },
                                      [_vm._v("×")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "col-md-12  " }, [
                              _c(
                                "div",
                                { staticClass: "layout_2" },
                                [
                                  _vm._t("body", function () {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "upload-outer" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "row",
                                              class:
                                                _vm.show_add_diatgnosticCenter
                                                  ? "mart-50"
                                                  : " ",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row choose-select-hold",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-12  px-0",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-12  px-0 text-center file-detail-hold",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pull-left tags-hold w-100 ",
                                                            },
                                                            [
                                                              _c(
                                                                "ul",
                                                                {
                                                                  staticClass:
                                                                    "list",
                                                                },
                                                                _vm._l(
                                                                  _vm.selectedFiles,
                                                                  function (
                                                                    item
                                                                  ) {
                                                                    return _c(
                                                                      "li",
                                                                      {
                                                                        attrs: {
                                                                          "data-toggle":
                                                                            "tooltip",
                                                                          title:
                                                                            item.name,
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              item.name
                                                                            ) +
                                                                            "\n                                                                    "
                                                                        ),
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                href: "javascript:void(0);",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  $event.preventDefault()
                                                                                  return _vm.removeFile(
                                                                                    item
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "×"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          ),
                                                          _vm.filecountcanbeuploaded
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "file-upload btn btn-default text-center",
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.browseBtnTxt
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _c("input", {
                                                                    ref: "upload",
                                                                    staticClass:
                                                                      "upload",
                                                                    attrs: {
                                                                      type: "file",
                                                                      id: "uploadFile1",
                                                                      name: "uploadFile",
                                                                      accept:
                                                                        "image/*, application/pdf",
                                                                      multiple:
                                                                        "",
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.validateFile()
                                                                        },
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.resetFile()
                                                                        },
                                                                    },
                                                                  }),
                                                                ]
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "file-upload ml-3",
                                                                },
                                                                [
                                                                  _vm.filescanbeuploaded ==
                                                                  0
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "alert-red1 L-inline text-center",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "mb-0",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "You have already uploaded maximum number of files allowed."
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "info-upload-i",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "d-block ml-3 mb-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "png, jpeg, webp and pdf "
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  " No bigger than " +
                                                                    _vm._s(
                                                                      _vm.gett_allowedFileSize /
                                                                        1024 /
                                                                        1024
                                                                    ) +
                                                                    "MB"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          !_vm.validFileExt &&
                                                          !_vm.validFileSize
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "d-block",
                                                                  style:
                                                                    !_vm.validFileExt &&
                                                                    !_vm.validFileSize
                                                                      ? "margin-left: -28px;"
                                                                      : "",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "info-upload-mail",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Invalid file size. Maximum " +
                                                                          _vm._s(
                                                                            _vm.gett_allowedFileSize /
                                                                              1024 /
                                                                              1024
                                                                          ) +
                                                                          "MB size allowed"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : !_vm.validFileExt
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "d-block",
                                                                  style:
                                                                    !_vm.validFileExt
                                                                      ? "margin-left: -28px;"
                                                                      : "",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "info-upload-mail",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Invalid file type"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : !_vm.validFileSize
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "d-block",
                                                                  style:
                                                                    !_vm.validFileSize
                                                                      ? "margin-left: -28px;"
                                                                      : "",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "info-upload-mail",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Selected file size is invalid"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : !_vm.validFileCount
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "d-block",
                                                                  style:
                                                                    !_vm.validFileCount
                                                                      ? "margin-left: -28px;"
                                                                      : "",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "info-upload-mail error-info",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Max of " +
                                                                          _vm._s(
                                                                            _vm.filescanbeuploaded
                                                                          ) +
                                                                          " files allowed"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row wd-100 mt-0 model-foot",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-12 padr-0",
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "av-btn-primary pull-right ripple",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.SaveReport(
                                                                false,
                                                                false
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("Save & close")]
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "av-btn-ghost pull-right ripple pdr-r10",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.closePopUp(
                                                                "goBack"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("Back")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.updateModal
        ? _c(
            "div",
            [
              _c("transition", { attrs: { name: "modal" } }, [
                _c("div", { staticClass: "modal-mask upl-hold" }, [
                  _c("div", { staticClass: "modal-wrapper" }, [
                    _c("div", { staticClass: "modal-container wider-midB" }, [
                      _c(
                        "div",
                        { staticClass: "modal-header" },
                        [
                          _vm._t("header", function () {
                            return [
                              _c("h5", { staticClass: "modal-title mt-3" }, [
                                _vm._v("Update web report"),
                              ]),
                              _c(
                                "button",
                                {
                                  staticClass: "close up-close",
                                  attrs: {
                                    type: "button",
                                    "aria-label": "Close",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.closePopUp("goBack")
                                    },
                                  },
                                },
                                [_vm._v("×")]
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                      _c("div", { staticClass: "modal-body" }, [
                        _c(
                          "div",
                          { staticClass: "layout_2" },
                          [
                            _vm._t("body", function () {
                              return [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c(
                                        "div",
                                        { staticClass: "container-comm" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "pdr-12" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.selected_report_type
                                                    .report_type
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "valid",
                                              attrs: { for: "days" },
                                            },
                                            [_c("b", [_vm._v("Report type")])]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c(
                                        "div",
                                        { staticClass: "container-comm" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "pdr-12" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.selected_test_type
                                                    .test_name
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "valid",
                                              attrs: { for: "days" },
                                            },
                                            [_c("b", [_vm._v("Test type")])]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c("div", { staticClass: "row mb-3 mt-2" }, [
                                  _c("div", { staticClass: "col-md-3" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "add-new-btn addnote-inline",
                                        staticStyle: { float: "initial" },
                                        attrs: {
                                          href: "javascript:void(0);",
                                          id: "add_category",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.showHideNote()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                          Add note\n                                          "
                                        ),
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("add")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "col-md-12 " }, [
                                    _c("div", { staticClass: " clr-bothmr" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-12 mt-2 pl-0 pr-0",
                                        },
                                        [
                                          _vm.showNote
                                            ? _c("div", {}, [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group mb-0",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "container-TXT",
                                                      },
                                                      [
                                                        _vm.selected_report_type &&
                                                        _vm.selected_report_type
                                                          .report_type &&
                                                        _vm.selected_test_type &&
                                                        _vm.selected_test_type
                                                          .test_name
                                                          ? _c("textarea", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.report_notes,
                                                                  expression:
                                                                    "report_notes",
                                                                },
                                                              ],
                                                              attrs: {
                                                                rows: "4",
                                                                autocomplete:
                                                                  "off",
                                                                name: "uname",
                                                                title: "",
                                                                required: "",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm.report_notes,
                                                              },
                                                              on: {
                                                                input: [
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.report_notes =
                                                                      $event.target.value
                                                                  },
                                                                  _vm.countChar,
                                                                ],
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              for: "fname",
                                                            },
                                                          },
                                                          [
                                                            _c("b", [
                                                              _vm._v("Note "),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-2000",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.report_notes
                                                              .length +
                                                              "/" +
                                                              _vm.totalcharallowedfornote
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c("div", { staticClass: "upload-outer" }, [
                                  _c("div", { staticClass: "row" }, [
                                    _vm.selected_reportSubmitMethod ===
                                      "_web" &&
                                    _vm.webReportDetailsArr &&
                                    _vm.webReportDetailsArr.length
                                      ? _c(
                                          "div",
                                          { staticClass: "web-repo-hold" },
                                          _vm._l(
                                            _vm.webReportDetailsArr,
                                            function (item, index) {
                                              return _c(
                                                "div",
                                                {
                                                  attrs: {
                                                    id: "weburlsection",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row mb-3" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-12",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-group",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "container-comm",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "select",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "select",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  item.selectedDiagCenter,
                                                                                expression:
                                                                                  "item.selectedDiagCenter",
                                                                              },
                                                                            ],
                                                                          staticClass:
                                                                            "select-text show-first",
                                                                          attrs:
                                                                            {
                                                                              title:
                                                                                "",
                                                                              required:
                                                                                "",
                                                                            },
                                                                          on: {
                                                                            change:
                                                                              [
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  var $$selectedVal =
                                                                                    Array.prototype.filter
                                                                                      .call(
                                                                                        $event
                                                                                          .target
                                                                                          .options,
                                                                                        function (
                                                                                          o
                                                                                        ) {
                                                                                          return o.selected
                                                                                        }
                                                                                      )
                                                                                      .map(
                                                                                        function (
                                                                                          o
                                                                                        ) {
                                                                                          var val =
                                                                                            "_value" in
                                                                                            o
                                                                                              ? o._value
                                                                                              : o.value
                                                                                          return val
                                                                                        }
                                                                                      )
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "selectedDiagCenter",
                                                                                    $event
                                                                                      .target
                                                                                      .multiple
                                                                                      ? $$selectedVal
                                                                                      : $$selectedVal[0]
                                                                                  )
                                                                                },
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.getIndexedSelectedDiagnosticCenter(
                                                                                    item,
                                                                                    index
                                                                                  )
                                                                                },
                                                                              ],
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "option",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  selected:
                                                                                    "",
                                                                                  value:
                                                                                    "OTHERS",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Others"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._l(
                                                                            _vm.finalDiagnosticList,
                                                                            function (
                                                                              diag
                                                                            ) {
                                                                              return _c(
                                                                                "option",
                                                                                {
                                                                                  domProps:
                                                                                    {
                                                                                      value:
                                                                                        diag.unique_id,
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      diag.name
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                        ],
                                                                        2
                                                                      ),
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "select-label",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Diagnostic centre name"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      item.showAddDiagBtn
                                                                        ? _c(
                                                                            "button",
                                                                            {
                                                                              staticClass:
                                                                                "primary-btn add-category-btn add-dcn",
                                                                              attrs:
                                                                                {
                                                                                  title:
                                                                                    "",
                                                                                  "data-toggle":
                                                                                    "tooltip",
                                                                                  "data-original-title":
                                                                                    "",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    $event.preventDefault()
                                                                                    return _vm.show_add_indexed_diatgnosticCenter_part(
                                                                                      item,
                                                                                      index
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              item.show_add_diatgnosticCenter
                                                                                ? _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        "-"
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        "+"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      item.show_add_diatgnosticCenter
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-md-12 mt-3 mb-3",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-group",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "container-comm",
                                                                    },
                                                                    [
                                                                      item.show_add_diatgnosticCenter
                                                                        ? _c(
                                                                            "div",
                                                                            {},
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {},
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {},
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticStyle:
                                                                                            {
                                                                                              "margin-bottom":
                                                                                                "10px",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {},
                                                                                            [
                                                                                              _c(
                                                                                                "input",
                                                                                                {
                                                                                                  directives:
                                                                                                    [
                                                                                                      {
                                                                                                        name: "model",
                                                                                                        rawName:
                                                                                                          "v-model",
                                                                                                        value:
                                                                                                          _vm.selectedDiagCenterTemp,
                                                                                                        expression:
                                                                                                          "selectedDiagCenterTemp",
                                                                                                      },
                                                                                                    ],
                                                                                                  attrs:
                                                                                                    {
                                                                                                      type: "text",
                                                                                                      autocomplete:
                                                                                                        "off",
                                                                                                      name: "uname",
                                                                                                      required:
                                                                                                        "",
                                                                                                    },
                                                                                                  domProps:
                                                                                                    {
                                                                                                      value:
                                                                                                        _vm.selectedDiagCenterTemp,
                                                                                                    },
                                                                                                  on: {
                                                                                                    input:
                                                                                                      function (
                                                                                                        $event
                                                                                                      ) {
                                                                                                        if (
                                                                                                          $event
                                                                                                            .target
                                                                                                            .composing
                                                                                                        ) {
                                                                                                          return
                                                                                                        }
                                                                                                        _vm.selectedDiagCenterTemp =
                                                                                                          $event.target.value
                                                                                                      },
                                                                                                  },
                                                                                                }
                                                                                              ),
                                                                                              _c(
                                                                                                "label",
                                                                                                {
                                                                                                  attrs:
                                                                                                    {
                                                                                                      for: "email",
                                                                                                    },
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "b",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "btn-HS",
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        "Enter diagnostic centre name"
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "col-lg-12 pr-0",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "pull-right",
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "a",
                                                                                            {
                                                                                              staticClass:
                                                                                                "primary-btn ripple btn-HS save-category",
                                                                                              attrs:
                                                                                                {
                                                                                                  href: "javascript:void(0);",
                                                                                                },
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    $event.preventDefault()
                                                                                                    return _vm.addIndexedDiagnostic(
                                                                                                      item,
                                                                                                      _vm.selectedDiagCenterTemp
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Save"
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-12",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-group",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "container-comm",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            item.reportWebsiteUrl,
                                                                          expression:
                                                                            "item.reportWebsiteUrl",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "pdr-12",
                                                                    attrs: {
                                                                      type: "text",
                                                                      disabled:
                                                                        !_vm.selected_reportSubmitMethod ===
                                                                        "_web",
                                                                      id: "reportWebsiteUrlId",
                                                                      autocomplete:
                                                                        "off",
                                                                      name: "uname",
                                                                      title: "",
                                                                      required:
                                                                        "",
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        item.reportWebsiteUrl,
                                                                    },
                                                                    on: {
                                                                      input: [
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            item,
                                                                            "reportWebsiteUrl",
                                                                            $event
                                                                              .target
                                                                              .value
                                                                          )
                                                                        },
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.validateField(
                                                                            item,
                                                                            index
                                                                          )
                                                                        },
                                                                      ],
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      attrs: {
                                                                        for: "days",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          "Enter website"
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                  !item.validWebsiteUrl
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "info-upload",
                                                                          staticStyle:
                                                                            {
                                                                              color:
                                                                                "#AA0000",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Please enter a valid website.Example: https://www.google.com"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-group",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "container-comm",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            item.reportWebsiteUname,
                                                                          expression:
                                                                            "item.reportWebsiteUname",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "pdr-12",
                                                                    attrs: {
                                                                      type: "text",
                                                                      disabled:
                                                                        !(
                                                                          _vm.selected_reportSubmitMethod ===
                                                                            "_web" &&
                                                                          item.reportWebsiteUrl !=
                                                                            "" &&
                                                                          item.validWebsiteUrl
                                                                        ),
                                                                      id: "reportWebsiteUserId",
                                                                      name: "uname",
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        item.reportWebsiteUname,
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            item,
                                                                            "reportWebsiteUname",
                                                                            $event
                                                                              .target
                                                                              .value
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      attrs: {
                                                                        for: "days",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          "User name"
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-group",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "container-comm",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            item.reportWebsitePass,
                                                                          expression:
                                                                            "item.reportWebsitePass",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "pdr-12",
                                                                    attrs: {
                                                                      disabled:
                                                                        !(
                                                                          _vm.selected_reportSubmitMethod ===
                                                                            "_web" &&
                                                                          item.reportWebsiteUrl !=
                                                                            "" &&
                                                                          item.reportWebsiteUname !=
                                                                            ""
                                                                        ),
                                                                      type: "text",
                                                                      id: "reportWebsitePassId",
                                                                      autocomplete:
                                                                        "off",
                                                                      name: "editpass",
                                                                      title: "",
                                                                      required:
                                                                        "",
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        item.reportWebsitePass,
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            item,
                                                                            "reportWebsitePass",
                                                                            $event
                                                                              .target
                                                                              .value
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      attrs: {
                                                                        for: "editpass",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          "Password"
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row",
                                        staticStyle: { "margin-top": "0px" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12 mt-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-group mb-0",
                                              },
                                              [
                                                _c("div", {
                                                  staticClass: "container-TXT",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "row wd-100 mt-0" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12 padr-0" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "primary-btn pull-right ripple",
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.SaveReport(
                                                      false,
                                                      true
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Save & close")]
                                            ),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "secondary-btn pull-right ripple pdr-r10",
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.closePopUp(
                                                      "goBack"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Back")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]
                            }),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isdisplaymsg
            ? _c("Messages", {
                attrs: {
                  iserror: _vm.iserrormsg,
                  datamessage: _vm.sucessmsgtext,
                  isVisible: _vm.isdisplaymsg,
                },
                on: { closemsg: _vm.closeMessage },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._m(0),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "modal fade analysize",
        attrs: {
          id: "analysize",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "exampleModalCenterTitle",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered modal-lg",
            attrs: { role: "document" },
          },
          [
            _c("div", { staticClass: "modal-content p-0" }, [
              _c("div", { staticClass: "modal-header pt-4" }, [
                _c("h3", { staticStyle: { color: "#000" } }, [
                  _vm._v("AI Medical Report"),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-label": "Close",
                    },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×"),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "modal-body mt-0" }, [
                _c("h4", [_vm._v("Heading 2")]),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. "
                    ),
                  ]),
                  _c("li", [
                    _vm._v(
                      "Suspendisse sed turpis tortor. In tempus dui a velit elementum"
                    ),
                  ]),
                  _c("li", [
                    _vm._v(
                      "Suspendisse non nisi non nibh finibus imperdiet eget quis sem."
                    ),
                  ]),
                  _c("li", [
                    _vm._v(
                      "Cras non gravida justo. Mauris tincidunt est diam, a blandit purus porta ac. "
                    ),
                  ]),
                  _c("li", [
                    _vm._v(
                      "In quis turpis interdum lectus consectetur faucibus."
                    ),
                  ]),
                ]),
                _c("h4", [_vm._v("Heading 1")]),
                _c("p", [
                  _vm._v(
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In quis turpis interdum lectus consectetur faucibus. Mauris non quam vitae nulla vulputate interdum. Nunc sodales porttitor pharetra. Curabitur sed orci urna. Phasellus a mattis diam, a luctus augue. Nulla eu fringilla eros. Nulla nec rutrum diam. Morbi sem purus, blandit in efficitur et, porttitor id est. Integer id tellus rhoncus, malesuada lorem ut, accumsan felis.\n       "
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    "\nSuspendisse sed turpis tortor. In tempus dui a velit elementum, nec ultrices sem aliquet. Nunc nisl dolor, fringilla ut egestas at, accumsan sed ante. Curabitur fringilla magna ligula, vitae malesuada ligula rhoncus id. Etiam varius, sem id vestibulum vulputate, nunc massa molestie arcu, et pellentesque eros tellus vel nulla. Phasellus dignissim enim in scelerisque vestibulum. Fusce libero lectus, bibendum vitae cursus vitae, consequat eget tortor. Duis mattis odio non dui egestas, nec scelerisque sapien dictum.\n    "
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    "\nFusce vulputate luctus mi, sed laoreet risus facilisis id. Suspendisse potenti. Quisque ornare lorem vitae neque lacinia, ut euismod dolor posuere. Ut tempor velit felis, sit amet tempus elit porta et. Quisque vel odio sed elit aliquam rutrum. Maecenas eu lacinia neque, eu pharetra purus. Sed consequat tortor nec ligula imperdiet, a faucibus mauris tempus. In semper ut eros ac pretium.\n"
                  ),
                ]),
              ]),
              _c("div", { staticClass: "modal-footer pt-0" }, [
                _c("button", { staticClass: "primary-btn pull-right ripple" }, [
                  _vm._v("Save & Continue"),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }